import React, { useState } from "react";
import AdultDetail from "../AllTabs/AdultTabs/AdultDetail";
import AdultStays from "../AllTabs/AdultTabs/AdultStays";
import Agent from "../AllTabs/AdultTabs/Agent";
import GroupMemberships from "../AllTabs/AdultTabs/GroupMemberships";
import Staff from "../AllTabs/AdultTabs/Staff";
import { isAdmin } from "../shared utils/auth";
import '../../styles/Tabs.css';



const AdultTabs = (props) => {

    const { selectedPerson, onClose } = props;
    const [activeTab, setActiveTab] = useState("details");
    const [selectedStay, setSelectedStay] = useState(null);

    const handledetails = () => {
        setActiveTab("details");
    };
    const handleagent = () => {
        setActiveTab("agent");       
    };
    const handleGroups = () => {
        setActiveTab("groups");
    };
    const handleStaff = () => {
        setActiveTab("staff");
    };
    const handlestays = () => {
        setActiveTab("stays");
    };
  
    const handleClose = () => {
        if (onClose) {
            onClose();
        }
    };
  
    return (
        <div className="Tabs">
            {/* Tab nav */}
            <ul className="nav">
                <li
                    className={activeTab === "details" ? "active" : ""}
                    onClick={handledetails}>
                Details
                </li>
                {/* Agent is an ADMIN-feature gate (distinct from financials). */}
                {isAdmin() && (
                    <li
                        className={activeTab === "agent" ? "active" : ""}
                        onClick={handleagent}>
                    Agent
                    </li>
                )}
                <li
                    className={activeTab === "groups" ? "active" : ""}
                    onClick={handleGroups}>
                Operational
                </li>
                <li
                    className={activeTab === "staff" ? "active" : ""}
                    onClick={handleStaff}>
                Staff
                </li>
                <li
                    className={activeTab === "stays" ? "active" : ""}
                    onClick={handlestays}>
                Stays
                </li>
               <li
                    className="close-tab"
                    onClick={handleClose}>
                Close
                </li>
            </ul>
            <div className="outlet">
                {activeTab === "details" ? <AdultDetail selectedPerson={selectedPerson} selectedStay={selectedStay} setSelectedStay={setSelectedStay} showFinancials={props.showFinancials} onClose={onClose} /> : null}
                {isAdmin() && activeTab === "agent" ? <Agent selectedPerson={selectedPerson}/> : null}
                {activeTab === "groups" ? <GroupMemberships selectedPerson={selectedPerson}/> : null}
                {activeTab === "staff" ? <Staff selectedPerson={selectedPerson}/> : null}
                {activeTab === "stays" && <AdultStays selectedPerson={selectedPerson} selectedStay={selectedStay} showFinancials={props.showFinancials}/>}
            </div>
        </div>
  );
};
export default AdultTabs;
